var map = {
	"./tidings0.png": "EJ66",
	"./tidings1.png": "GHEQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3gWz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/header ^\.\/tidings.*\.png$
// module id = 3gWz
// module chunks = 3